const authors = [
  {
    nickname: "bacter",
    name: "Yitzchak Shemesh-Sarel",
    country: "Israel",
    member: true,
  },
  { nickname: "cemik", name: "Carl Waern", country: "Sweden" },
  {
    nickname: "dna-groove",
    name: "Eliran Ben-Ishay",
    country: "Israel",
    member: true,
  },
  {
    nickname: "dualtrax",
    name: "Marco Stahl",
    country: "Germany",
    member: true,
  },
  {
    nickname: "drax",
    name: "Thomas Laurits Vedel Mogensen",
    country: "Danemark",
  },
  {
    nickname: "edzes",
    name: "Andreas Bruvoll Skaarung",
    country: "Norway",
    member: true,
  },
  { nickname: "ernestoaeroflot", name: "Teemu Kiiskilä", country: "Finland" },
  { nickname: "forsaken", country: "?", name: "?" },
  { nickname: "genuiz", name: "Marek Nowak", country: "Germany" },
  {
    nickname: "jashiin",
    name: "Vladimir Seletsky",
    country: "Russia",
    member: true,
  },
  {
    nickname: "keen",
    name: "Oleksij Komarchuk",
    country: "Ukraine",
    member: true,
  },
  {
    nickname: "kenet",
    name: "Raphaël Quercy",
    country: "France",
    member: true,
  },
  { nickname: "keyg", name: "Konrad Gmurek", country: "Poland" },
  { nickname: "ks", name: "Fabien Lasserre", country: "France" },
  {
    nickname: "med",
    name: "Cyril Pereira",
    country: "France",
    url: "https://med.funkylab.fr",
    member: true,
  },
  { nickname: "nagz", name: "David Halmi", country: "Hungary", member: true },
  { nickname: "poulpy", country: "?", name: "?" },
  {
    nickname: "redribbon",
    name: "Guillaume Romero",
    country: "France",
    member: true,
  },
  { nickname: "rez", name: "Christophe Resigné", country: "France" },
  {
    nickname: "skybax",
    name: "Jonny Jansson (",
    country: "Finland",
    member: true,
  },
  { nickname: "tomaes", country: "Germany" },
  {
    nickname: "traven",
    name: "Romain Gauthier",
    country: "France",
    member: true,
  },
  {
    nickname: "unaware",
    name: "Marcin Stachyra",
    country: "Poland",
    member: true,
  },
  {
    nickname: "vhiiula",
    name: "Andre Seffrin",
    country: "Germany",
    member: true,
  },
  { nickname: "wayfinder", name: "Sebastian Grillmaier", country: "Germany" },
  { nickname: "willbe", name: "William Lamy", country: "France", member: true },
  { nickname: "xerxes", name: "Klaus Lunde", country: "Norway", member: true },
];

export default authors;
